import { Component, Input, OnInit } from '@angular/core';
import { ConfigService, ShippingCard } from 'src/app/services';

@Component({
	selector: 'app-shipping-card',
	templateUrl: './shipping-card.component.html',
	styleUrls: ['./shipping-card.component.scss'],
})
export class ShippingCardComponent implements OnInit {
	@Input() card: ShippingCard = {};
	activateUrl: string = '';

	constructor(private readonly configService: ConfigService) {}

	ngOnInit() {
		this.activateUrl = `${this.configService.webBaseUrl}activate`;
	}
}
